import type { GetFeedbackForCoopResponse, JsonObject } from '@/app-package';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

export type GetFeedbackForCoopOptions = {
  listingId: string;
  appointmentId: string;
};

export type FeedbackForCoop = JsonObject<GetFeedbackForCoopResponse>;

const getFeedbackForCoop = async ({
  listingId,
  appointmentId,
}: GetFeedbackForCoopOptions) => {
  const config: AxiosRequestConfig = {
    url: `/user/coop/listing/${listingId}/appointment/${appointmentId}/feedback`,
    method: 'get',
  };

  const { data } = await axios.request<FeedbackForCoop>(config);

  return data;
};

export default getFeedbackForCoop;
